export default __webpack_public_path__ + "static/media/evolving-sustainability-practices-and-global-trends.8bb173d4.jpg";